import { procedureManageRoute } from './manage.route';

export const procedureEditRoute = procedureManageRoute('edit', 'procedureEdit', 'Edycja procedury', [
  { title: 'Nazwa', name: `procedureEditBase` },
  { title: 'Załączniki', name: `procedureEditAttachments` },
  { title: 'Opis', name: `procedureEditDescription` }
]);
